import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';

const DescriptionSection = (props) => {
  const { children } = props;
  return (
    <StyledSection>
      <Title>{children}</Title>
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  padding-top: 90px;
  text-align: center;
  margin-bottom: 125px;
`;
const Title = styled.h2`
  text-align: center;
  font-size: var(--heading-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--blue-dark);
`;

export default DescriptionSection;
